import React, { useMemo, useState } from "react";
import UserAvatar from "../../Common/UserAvatar";
import UIIcon from "../../Common/UIIcon";
import { copyTextToClipboardSafe } from "../../APanel/CalendarPlus/utils";

function StudentItemInline({
   student,
   color,
   initials,
   secondaryText,
   showIdnp = true,
   /** Shown first under the name (e.g. group). */
   metaLeft = null,
   /** Phone line with copy button (EditReservation-style). */
   showPhoneCopy = false,
   className = "",
}) {
   const [copied, setCopied] = useState(false);

   const fullName = useMemo(() => {
      const fn = String(student?.firstName || "").trim();
      const ln = String(student?.lastName || "").trim();
      return `${fn} ${ln}`.trim();
   }, [student]);

   const phoneText = String(
      secondaryText ?? student?.phone ?? student?.phoneNumber ?? "",
   ).trim();
   const idnp = String(student?.idnp ?? "").trim();
   const groupText = metaLeft != null ? String(metaLeft).trim() : "";

   const handleCopyPhone = async (event) => {
      event?.stopPropagation?.();
      if (!phoneText) return;
      const ok = await copyTextToClipboardSafe(phoneText);
      if (!ok) return;
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
   };

   let metaContent;
   if (metaLeft != null || showPhoneCopy) {
      metaContent = (
         <span className="studentItem__metaRow">
            {groupText ? (
               <span className="studentItem__metaGroup">{groupText}</span>
            ) : null}
            {phoneText ? (
               <span className="studentItem__metaPhone">
                  {groupText ? (
                     <span className="studentItem__metaSep" aria-hidden="true">
                        ·
                     </span>
                  ) : null}
                  <span className="studentItem__metaPhoneText">{phoneText}</span>
                  {showPhoneCopy ? (
                     <button
                        type="button"
                        className="studentItem__copyBtn"
                        title={copied ? "Copiat" : "Copiază telefonul elevului"}
                        aria-label={
                           copied ? "Telefon copiat" : "Copiază telefonul elevului"
                        }
                        disabled={!phoneText}
                        onClick={handleCopyPhone}
                     >
                        <UIIcon name="copy" className="studentItem__copyIcon" />
                     </button>
                  ) : null}
               </span>
            ) : !groupText ? (
               <span className="studentItem__metaPhoneText">—</span>
            ) : null}
         </span>
      );
   } else {
      const fallbackPhone = phoneText || "—";
      metaContent =
         showIdnp && idnp
            ? `${fallbackPhone} · IDNP ${idnp}`
            : fallbackPhone;
   }

   return (
      <div className={`studentItem ${className}`}>
         <UserAvatar
            person={student}
            color={color}
            initials={initials}
            className="studentItem__avatar"
         />

         <div className="studentItem__info">
            <h3 className="studentItem__name">{fullName || "–"}</h3>
            <p className="studentItem__meta">{metaContent || "—"}</p>
         </div>
      </div>
   );
}

export default StudentItemInline;
